import { useEffect, useRef } from "react";
import ZoomImage from "./ZoomImage";
import useSwipe from "./hooks/useSwipe";

export default function GalleryMain({ gallery,
    next,
    previous,
}) {

    const swipe = useSwipe({
        onNext: gallery.next,
        onPrevious: gallery.previous,
    });

    if (!gallery.selected) return null;

    return (

        <div
            className="gallery-main"
            onClick={gallery.openModal}
            onTouchStart={swipe.onTouchStart}
            onTouchEnd={swipe.onTouchEnd}
        >
            <ZoomImage
                image={gallery.selected}
                hoverZoom={true}
                wheelZoom={false}
                draggable={false}
            />
        </div>

    );

}